import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/Tooltip"
import { PRODUCTS } from "../data"

const MENTION = /(#[A-Za-z0-9-]+)/g

// A note with every #SKU turned into a product link, like issue links on
// GitHub. In the real page the link opens the product quick view.
export default function NoteText({ note }: { note: string }) {
  return (
    <>
      {note.split(MENTION).map((part, i) => {
        const product = part.startsWith("#") ? PRODUCTS.find((p) => p.sku === part.slice(1)) : null
        if (!product) return <span key={i}>{part}</span>
        return (
          <Tooltip key={i}>
            <TooltipTrigger asChild>
              <span className="cursor-pointer font-medium text-primary underline decoration-primary/40 underline-offset-2">{part}</span>
            </TooltipTrigger>
            <TooltipContent>{product.name}</TooltipContent>
          </Tooltip>
        )
      })}
    </>
  )
}
